import React, { Component } from "react";
import MyTitle from "../myTitle";
import styleObj from "./style.module.scss";
import Live2021 from "./2021";

export default class Live extends Component {
  render() {
    let { liveAddress, meta } = this.props;
    if (!liveAddress) return null;
    return (
      <>
        {meta?.is2021 ? (
          <Live2021 {...this.props} />
        ) : (
          <div className={styleObj["review-wrap"]}>
            <MyTitle mainTitle="现场直播" subTitle="LIVE" />
            <div className={styleObj["content"]}>
              <iframe
                title="skyworth w92 系列体验趴"
                src={liveAddress && liveAddress.replace(/https?:/, "")}
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen={true}
              ></iframe>
              <img
                className={styleObj["pendant"]}
                src={require("../../assets/imgs/live stream.png")}
                alt=""
              />
            </div>
          </div>
        )}
      </>
    );
  }
}
